import { render, staticRenderFns } from "./GoodsItem2Skeleton.vue?vue&type=template&id=748eff03&scoped=true&"
import script from "./GoodsItem2Skeleton.vue?vue&type=script&lang=js&"
export * from "./GoodsItem2Skeleton.vue?vue&type=script&lang=js&"
import style0 from "./GoodsItem2Skeleton.vue?vue&type=style&index=0&id=748eff03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748eff03",
  null
  
)

export default component.exports